import React from 'react';
import App from './App';
import AuthenticationProvider, { LoginSettingsType } from './core/services/AuthenticationProvider';
import { useQuery } from 'react-query';
import Loader from './core/components/Loader/Loader';
import axios from 'axios';
import GlobalConfig from './core/api/GlobalConfig';

const AppLoader = () => {
  if (GlobalConfig.val().UseLegacyLogin) {
    return (
      <AuthenticationProvider>
        <App />
      </AuthenticationProvider>
    );
  }

  const {
    data: loginSettingsResponse,
    isLoading,
    error,
  } = useQuery('loginSettings', async () => {
    return await axios.get<LoginSettingsType>('Configuration/loginSettings', {
      baseURL: GlobalConfig.val().GatewayApiUrl,
    });
  });

  if (isLoading) {
    return <Loader />;
  }

  if (error) {
    return <div>Error loading settings</div>;
  }
  console.log('loginSettings:', loginSettingsResponse?.data);

  return (
    <AuthenticationProvider loginSettings={loginSettingsResponse?.data}>
      <App />
    </AuthenticationProvider>
  );
};

export default AppLoader;
